import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomizedAvailabilityListsComponent } from './customized-availability-lists.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InlineSVGModule } from "ng-inline-svg";
import { PipesModule } from "../../pipes/index";
import { CustomizedAvailabilityFormModule } from "../../forms/customized-availability-form";



@NgModule({
  declarations: [CustomizedAvailabilityListsComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule, ReactiveFormsModule,
    InlineSVGModule, PipesModule,
    CustomizedAvailabilityFormModule
  ],
  exports: [CustomizedAvailabilityListsComponent]
})
export class CustomizedAvailabilityListsModule { }
